import {
  BarChart3,
  Key,
  Package,
  Settings,
  ShieldCheck,
  ShoppingCart,
  Users,
  Wallet,
  Wrench,
  type LucideIcon,
} from 'lucide-react';
import type { WorkflowCategory } from './types';

export interface CategoryConfig {
  labelKey: string;
  icon: LucideIcon;
  order: number;
}

export const CATEGORY_CONFIG: Record<WorkflowCategory, CategoryConfig> = {
  finance: { labelKey: 'integration.flow.categories.finance', icon: Wallet, order: 1 },
  rental: { labelKey: 'integration.flow.categories.rental', icon: Key, order: 2 },
  service: { labelKey: 'integration.flow.categories.service', icon: Wrench, order: 3 },
  inventory: { labelKey: 'integration.flow.categories.inventory', icon: Package, order: 4 },
  sales: { labelKey: 'integration.flow.categories.sales', icon: ShoppingCart, order: 5 },
  reporting: { labelKey: 'integration.flow.categories.reporting', icon: BarChart3, order: 6 },
  compliance: { labelKey: 'integration.flow.categories.compliance', icon: ShieldCheck, order: 7 },
  hr: { labelKey: 'integration.flow.categories.hr', icon: Users, order: 8 },
  operations: { labelKey: 'integration.flow.categories.operations', icon: Settings, order: 9 },
};
